(() => {
  'use strict';
  if (window.FemiEkoTestLanding) { window.FemiEkoTestLanding.refresh(); return; }
  const state = { once: new Set(), observer: null };
  const inEditor = () => Boolean(window.Shopify && window.Shopify.designMode);
  function analyticsAllowed() {
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) {
        return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
      }
      return window.FEMIEKO_ANALYTICS_CONSENT === true;
    } catch (_) { return false; }
  }
  function emit(action) {
    if (inEditor() || !analyticsAllowed()) return;
    const data = { event: 'femieko_test_tamponului', action };
    document.dispatchEvent(new CustomEvent('femieko:measure', { detail: data }));
    // No gtag or external tracker is installed by this package.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
  function emitOnce(key, action) {
    if (state.once.has(key) || !analyticsAllowed() || inEditor()) return;
    state.once.add(key); emit(action);
  }
  function sections() {
    return Array.from(document.querySelectorAll('[data-tt-section]')).filter(el => el.getClientRects().length > 0 && getComputedStyle(el).display !== 'none');
  }
  function syncWaves() {
    const list = sections();
    list.forEach((el, i) => {
      const previous = list[i - 1];
      el.style.setProperty('--tt-wave-from', getComputedStyle(previous || el).backgroundColor);
    });
  }
  function wireVideo(player) {
    if (player.dataset.ttWired) return;
    player.dataset.ttWired = 'true';
    const video = player.querySelector('video');
    const gate = player.querySelector('[data-tt-gate]');
    const reveal = player.querySelector('[data-tt-reveal]');
    if (!video || !gate || !reveal) return;
    video.autoplay = false; video.removeAttribute('autoplay');
    reveal.addEventListener('click', () => {
      if (reveal.disabled) return;
      gate.hidden = true;
      video.pause();
      video.focus({ preventScroll: true });
      emit('video_reveal');
    });
    video.addEventListener('play', () => {
      if (!gate.hidden) { video.pause(); return; }
      emitOnce('video_play', 'video_play');
    });
    video.addEventListener('error', () => {
      gate.hidden = false;
      gate.querySelector('div').textContent = 'Materialul nu poate fi încărcat momentan. Încearcă din nou mai târziu.';
      reveal.disabled = true; reveal.textContent = 'Video indisponibil';
    });
  }
  function scrollCheck() {
    const list = sections(); if (!list.length) return;
    const top = list[0].getBoundingClientRect().top + window.scrollY;
    const last = list[list.length - 1];
    const end = last.getBoundingClientRect().bottom + window.scrollY;
    if (window.scrollY + window.innerHeight >= top + (end - top) / 2) emitOnce('scroll_50', 'scroll_50');
  }
  function refresh() {
    syncWaves();
    document.querySelectorAll('[data-tt-player]').forEach(wireVideo);
    if (state.observer) state.observer.disconnect();
    const test = document.querySelector('[data-tt-kind="test"]');
    if (test && 'IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) emitOnce('test_section_view', 'test_section_view');
      }, { threshold: 0.2 });
      state.observer.observe(test);
    }
    scrollCheck();
  }
  window.FemiEkoTestLanding = { refresh };
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-tt-event]');
    if (target?.closest('[data-tt-section]')) emit(target.dataset.ttEvent);
  });
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'visitorConsentCollected'].forEach(name => {
    document.addEventListener(name, () => requestAnimationFrame(refresh));
  });
  window.addEventListener('resize', syncWaves, { passive: true });
  window.addEventListener('scroll', scrollCheck, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
